module.exports = __webpack_public_path__ + "img/menucn_6_1.f84717a3.svg";